import { OptionCode } from '../../enums';
import mockedPaginatedResponse from './mockedPaginatedResponse';
import mockedRequester from './mockedRequester';
export const mockedPlotOptionActivation = {
    end: '1409067214',
    id: 3,
    optionCode: OptionCode.irrelis,
    plotId: 5,
    plotName: 'foobar',
    remainingTokens: 4,
    start: '1377531214',
    stationId: 2
};
const mock = {
    delete: mockedRequester(undefined, 'plotOptionActivations.delete'),
    get: mockedRequester(mockedPlotOptionActivation, 'plotOptionActivations.get'),
    getAllPages: mockedRequester([mockedPlotOptionActivation], 'plotOptionActivations.getAllPages'),
    getMany: mockedRequester(mockedPaginatedResponse([mockedPlotOptionActivation]), 'plotOptionActivations.getMany'),
    getPage: mockedRequester(mockedPaginatedResponse([mockedPlotOptionActivation]), 'plotOptionActivations.getPage'),
    requestReActivation: mockedRequester(undefined, 'plotOptionActivations.requestReActivation')
};
export default mock;
